import __isEmpty from 'lodash/isEmpty';

export const INPUT_ERROR__EMPTY_PASSWORD = 'Enter a password';
export const INPUT_ERROR__MIN_CHAR = 'Enter a password with at least 8 characters';
export const INPUT_ERROR__NO_UPPER_CASE = 'Enter a password with at least one upper case letter';
export const INPUT_ERROR__NO_LOWER_CASE = 'Enter a password with at least one lower case letter';
export const INPUT_ERROR__NO_NUM_OR_SPECIAL_CHAR = 'Enter a password with at least one number or special character';
export const INPUT_ERROR__HAS_SPACES = 'Enter a password that contains no space';
export const INPUT_ERROR__HAS_EMOJI = 'Enter a password that contains no emoji';


function validateMinLength(minLength, value) {
    return !!value && value.length >= minLength;
}

function validateNoWhitespace(value) {
    return !/\s/.test(value);
}

function validateCharacterAllowlist(value) {
    // This regex only includes white space to not trigger the same validation error as no whitespace
    return value.replace(/[a-z0-9=+-^$*.[\]{}()?"!@#%&\s/\\,><':;|_~`]/ig, '').length === 0;
}

function validateUpperCase(value) {
    return /[A-Z]/.test(value);
}

function validateLowerCase(value) {
    return /[a-z]/.test(value);
}

function validateNumOrSpecialChar(value) {
    return /[^a-zA-Z]/.test(value);
}

export function checkPassword(password) {
    const error = [];

    if (__isEmpty(password)) {
      error.push(INPUT_ERROR__EMPTY_PASSWORD);
    } else {
      if (!validateMinLength(8, password)) {
        error.push(INPUT_ERROR__MIN_CHAR);
      }
      if (!validateUpperCase(password)) {
        error.push(INPUT_ERROR__NO_UPPER_CASE);
      }
      if (!validateLowerCase(password)) {
        error.push(INPUT_ERROR__NO_LOWER_CASE);
      }
      if (!validateNumOrSpecialChar(password)) {
        error.push(INPUT_ERROR__NO_NUM_OR_SPECIAL_CHAR);
      }
      if (!validateNoWhitespace(password)) {
        error.push(INPUT_ERROR__HAS_SPACES);
      }
      if (!validateCharacterAllowlist(password)) {
        error.push(INPUT_ERROR__HAS_EMOJI);
      }
    }

    return error;
  }